export enum DashboardWidgetName {
  AccountsByType = 'AccountsByType',
  CashFlowProjections = 'CashFlowProjections',
  Commitments = 'Commitments',
  IncomeChangeSnapshot = 'IncomeChangeSnapshot',
  IncomeHistoryBarsChart = 'IncomeHistoryBarsChart',
  IncomeHistoryTable = 'IncomeHistoryTable',
  IncomePivot = 'IncomePivot',
  IrrMoic = 'IrrMoic',
  LinkedTransactions = 'LinkedTransactions',
  LinkedTransactionsPivot = 'LinkedTransactionsPivot',
  OrganizationChart = 'OrganizationChart',
  PerformancePivot = 'PerformancePivot',
  SectionDelimiter = 'SectionDelimiter',
  TreePivot = 'TreePivot',
  ValueChangeSnapshot = 'ValueChangeSnapshot',
  ValueHistoryBarsChart = 'ValueHistoryBarsChart',
  ValueHistoryPieChart = 'ValueHistoryPieChart',
  ValueHistoryTable = 'ValueHistoryTable',
  ValuePivot = 'ValuePivot',
}
